// extracted by mini-css-extract-plugin
export default {"label":"style_label__XggXG","c":"style_c__yh7BU","e":"style_e__6rSAo","icon":"style_icon__QIQle"};